The details of the draft position to be previewed.
